import React, { Component } from 'react';

export default class Ordering extends Component {
  static type = 'ordering';
  static optionable = true;
  static elementName = 'Ordering';
  static icon = 'sort';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/ordering.js